import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { clearBillValue } from 'redux/modules/bills/actions';
import { billValueSelector } from 'redux/modules/bills/selectors';
import { loadQualtrics } from 'utils/qualtrics';
import PaymentConfirmedDialog from 'views/Bills/common/PaymentConfirmedDialog';
import PaymentRejectedDialog from 'views/Bills/common/PaymentRejectedDialog';

type dialogType = 'paymentConfirmed' | 'paymentRejected' | null;

const PaymentResult = () => {
	const dispatch = useDispatch();
	const billsValue = useSelector(billValueSelector);

	const [showDialog, setShowDialog] = useState<dialogType>(null);

	const showPaymentConfirmedDialog = () => {
		setShowDialog('paymentConfirmed');
	};

	const showPaymentRejectedDialog = () => {
		setShowDialog('paymentRejected');
	};

	const hideDialog = () => {
		setShowDialog(null);
		loadQualtrics({
			activity_type: `Bill Payment with Card  - ${showDialog === 'paymentConfirmed' ? 'Success' : 'Failure'}`,
		});
	};

	const hidePaymentConfirmedDialog = () => {
		hideDialog();
		dispatch(clearBillValue());
	};

	useEffect(() => {
		if (+billsValue === 0) return;

		if (location.search.includes('success')) {
			showPaymentConfirmedDialog();
		} else if (location.search.includes('failure')) {
			showPaymentRejectedDialog();
		}
	}, [location]);

	return (
		<>
			<PaymentConfirmedDialog
				isOpen={showDialog === 'paymentConfirmed'}
				hideDialog={hidePaymentConfirmedDialog}
			/>
			<PaymentRejectedDialog isOpen={showDialog === 'paymentRejected'} hideDialog={hideDialog} />
		</>
	);
};

export default PaymentResult;
